import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxsModule } from '@ngxs/store';
import { FormCommonModule } from '@x/common/form';
import { IconModule } from '@x/common/icon';
import { LoaderModule } from '@x/common/loader/loader.module';
import { ResponsiveModule } from '@x/common/responsive';
import { AddressModule } from '@x/ecommerce-shop/app/core/address/address.module';
import { AddressPipe } from '@x/ecommerce-shop/app/core/address/pipes/address.pipe';
import { AuthModule } from '@x/ecommerce-shop/app/core/auth/auth.module';
import { OrderShipmentNameComponent } from '@x/ecommerce-shop/app/core/order/components/order-shipment-name/order-shipment-name.component';
import { RegionButtonIconComponent } from '@x/ecommerce-shop/app/core/region/components/region-button-icon/region-button-icon.component';
import { RegionButtonComponent } from '@x/ecommerce-shop/app/core/region/components/region-button/region-button.component';
import { RegionDeliveryDetailsComponent } from '@x/ecommerce-shop/app/core/region/components/region-delivery-details/region-delivery-details.component';
import { RegionAddToCartDetailComponent } from '@x/ecommerce-shop/app/core/region/components/region-overlay/region-add-to-cart-flow/region-add-to-cart-detail.component';
import { RegionOverlayComponent } from '@x/ecommerce-shop/app/core/region/components/region-overlay/region-overlay.component';
import { RegionCodePipe } from '@x/ecommerce-shop/app/core/region/pipes/region-code.pipe';
import { RegionOverlayService } from '@x/ecommerce-shop/app/core/region/services/region-overlay.service';
import { RegionState } from '@x/ecommerce-shop/app/core/region/state/region.state';
import { RoutingModule } from '@x/ecommerce-shop/app/core/routing/routing.module';
import { CloseButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/close-button/close-button.module';
import { IconUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/icon-ui/icon-ui.module';
import { InputLoaderModule } from '@x/ecommerce-shop/app/core/shop-ui/components/input-loader/input-loader.module';
import { OverlayUiModule } from '@x/ecommerce-shop/app/core/shop-ui/components/overlay/overlay-ui.module';
import { ShopColorModule } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-color/shop-color.module';
import { ShopPillComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-pill/shop-pill.component';
import { IfShopConfigDirective } from '@x/ecommerce-shop/app/core/utils/directives/if-shop-config.directive';
import { UtilsModule } from '@x/ecommerce-shop/app/core/utils/utils.module';
import { RegionAddToCartFlowComponent } from './components/region-overlay/region-add-to-cart-flow/region-add-to-cart-flow.component';
import { RegionCollectComponent } from './components/region-overlay/region-normal-flow/region-collect.component';
import { RegionGotoChannelComponent } from './components/region-overlay/region-normal-flow/region-goto-channel.component';
import { RegionNormalFlowComponent } from './components/region-overlay/region-normal-flow/region-normal-flow.component';
import { RegionOverlayFooterComponent } from './components/region-overlay/region-overlay-footer.component';
import { RegionSearchComponent } from './components/region-overlay/region-search.component';
import { RegionSelectComponent } from './components/region-select/region-select.component';
import { RegionUserAddressesComponent } from './components/region-user-addresses/region-user-addresses.component';

@NgModule({
  providers: [AddressPipe, RegionOverlayService, RegionCodePipe],
  declarations: [
    RegionSelectComponent,
    RegionOverlayComponent,
    RegionNormalFlowComponent,
    RegionAddToCartFlowComponent,
    RegionOverlayFooterComponent,
    RegionOverlayComponent,
    RegionGotoChannelComponent,
    RegionCollectComponent,
    RegionSearchComponent,
    RegionAddToCartDetailComponent,
    RegionUserAddressesComponent,
    RegionButtonComponent,
    RegionButtonIconComponent,
  ],
  imports: [
    CommonModule,
    NgxsModule.forFeature([RegionState]),
    MatButtonModule,
    OverlayModule,
    OverlayUiModule,
    FormCommonModule,
    InputLoaderModule,
    RouterModule,
    LoaderModule,
    ResponsiveModule,
    UtilsModule,
    AddressModule,
    AuthModule,
    MatChipsModule,
    RoutingModule,
    MatTooltipModule,
    FontAwesomeModule,
    CloseButtonModule,
    IconUiModule,
    MatBadgeModule,
    IconModule,
    ShopColorModule,
    ShopPillComponent,
    OrderShipmentNameComponent,
    RegionDeliveryDetailsComponent,
    IfShopConfigDirective,
  ],
  exports: [RegionSelectComponent, RegionButtonComponent, RegionButtonIconComponent],
})
export class RegionModule {}
